/* blog-filters.js
 * Client-side category filter for the blog listing page.
 * Mirrors lovable-source/src/pages/BlogListing.tsx — clicking a category
 * button filters the posts grid (and hides the "Featured" card unless
 * "All" is selected).
 *
 * Each card carries data-blog-card-category="<first tag>". The featured
 * card carries data-blog-featured.
 */
(function () {
  'use strict';

  const filterContainer = document.querySelector('[data-blog-filters]');
  if (!filterContainer) return;

  const buttons = filterContainer.querySelectorAll('[data-blog-filter]');
  const cards = document.querySelectorAll('[data-blog-card]');
  const featured = document.querySelector('[data-blog-featured]');
  const empty = document.querySelector('[data-blog-empty]');
  if (!buttons.length || !cards.length) return;

  function apply(category) {
    let visible = 0;
    cards.forEach(function (card) {
      const cat = card.getAttribute('data-blog-card-category') || '';
      const show = category === 'All' || cat === category;
      if (show) {
        card.removeAttribute('data-blog-card-hidden');
        visible++;
      } else {
        card.setAttribute('data-blog-card-hidden', '');
      }
    });

    if (featured) {
      if (category === 'All') {
        featured.removeAttribute('data-blog-featured-hidden');
      } else {
        featured.setAttribute('data-blog-featured-hidden', '');
      }
    }

    if (empty) {
      if (visible === 0) empty.removeAttribute('hidden');
      else empty.setAttribute('hidden', '');
    }
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      buttons.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      apply(btn.getAttribute('data-blog-filter'));
    });
  });
})();
